import React from "react";
import { useT, useResources } from "~app/BundleProvider";

const IntroHeader = () => {
  const t = useT();
  const r = useResources();
  return (
    <header role="banner">
      <img
        src={require("~app/resources/images/flow-icon.svg")}
        alt={t("how-science-works-logo")}
        className="intro-header-icon"
      />

      <img
        src={r("header-title.svg")}
        alt={t("how-science-works")}
        className="intro-header-text"
      />
    </header>
  );
};

export default IntroHeader;



// WEBPACK FOOTER //
// ./src/pages/intro/IntroHeader.js